export function parseHTMLEntity(entity: string) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(entity, "text/html")
  return doc.documentElement.textContent
}
